export default __webpack_public_path__ + "static/media/pwa.51070224.png";